import React, { FC } from 'react'
import styles from './HeaderSection.module.scss'
import classNames from 'classnames'
type Props = {
  title?: string
  subTitle?: string
  description?: string
  customTitleStyle?: string
}
const HeaderSection: FC<React.PropsWithChildren<Props>> = ({
  title,
  subTitle,
  description,
  customTitleStyle = '',
}) => {
  return (
    <div className={styles.headerSection}>
      <h1
        className={classNames({
          [customTitleStyle]: customTitleStyle !== '',
          [styles.title]: customTitleStyle === '',
        })}
      >
        {title}
      </h1>
      <h2 className={styles.subTitle}>{subTitle}</h2>
      <p className={styles.description}>{description}</p>
    </div>
  )
}

export default HeaderSection
